import { Link } from "react-router-dom";
import { FileArrowDown, BookOpen } from "@phosphor-icons/react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader, StatusChip } from "./primitives";

const WhitepaperSection = () => {
  const config = useSiteConfig();
  return (
    <section id="whitepaper" className="relative py-24 lg:py-36 border-t border-line" data-testid="whitepaper-section">
      <div className="section-shell">
        <SectionHeader
          index={16}
          eyebrow="White Paper"
          title={<>Jovino Coin<br />Official White Paper</>}
          sub="The definitive technical and strategic documentation of the Jovino ecosystem. New versions build on this foundation — starting with presale and launch economics."
          testId="whitepaper-header"
        />
        <div className="mt-14 grid gap-5 md:grid-cols-2 max-w-4xl">
          {config.whitepaper.versions.map((v, i) => {
            const available = v.status === "AVAILABLE";
            return (
              <Reveal key={v.version} delay={i * 0.1} testId={`whitepaper-version-${v.version.replace(".", "-")}`}>
                <article className={`card-surface h-full rounded-xl p-8 flex flex-col ${available ? "border-teal/40" : "opacity-60"}`}>
                  <div className="flex items-center justify-between gap-3">
                    <span className={`font-mono text-xs tracking-[0.3em] uppercase ${available ? "text-teal" : "text-slate"}`}>
                      Version {v.version}
                    </span>
                    <StatusChip tone={available ? "teal" : "gold"} testId={`whitepaper-status-${v.version.replace(".", "-")}`}>
                      {v.status}
                    </StatusChip>
                  </div>
                  <h3 className="mt-5 font-display text-xl lg:text-2xl font-semibold text-mist">{v.title}</h3>
                  <div className="mt-auto pt-8 flex flex-wrap gap-3">
                    {available ? (
                      <>
                        <Link
                          to="/whitepaper"
                          data-testid="whitepaper-read-button"
                          className="inline-flex items-center gap-2 rounded-full bg-teal px-6 py-3 font-display font-semibold text-sm text-navy transition-transform duration-300 hover:scale-[1.03]"
                        >
                          <BookOpen size={18} /> Read White Paper
                        </Link>
                        {v.file && (
                          <a
                            href={v.file}
                            download
                            data-testid="whitepaper-download-button"
                            className="inline-flex items-center gap-2 rounded-full border border-line px-6 py-3 font-display font-semibold text-sm text-mist transition-colors duration-300 hover:border-gold hover:text-gold"
                          >
                            <FileArrowDown size={18} /> Download PDF
                          </a>
                        )}
                      </>
                    ) : (
                      <span className="font-mono text-xs tracking-[0.2em] uppercase text-slate" data-testid="whitepaper-v2-note">
                        Content to be published — not yet written
                      </span>
                    )}
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhitepaperSection;
